import { render, staticRenderFns } from "./CustomerPaymentStatusBadge.vue?vue&type=template&id=412d9a18"
import script from "./CustomerPaymentStatusBadge.vue?vue&type=script&lang=js"
export * from "./CustomerPaymentStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./CustomerPaymentStatusBadge.vue?vue&type=style&index=0&id=412d9a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports